var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                { attrs: { center: "" } },
                [
                  _c("div", { staticClass: "breadcrumb" }, [
                    _vm._v(" Roadmap "),
                  ]),
                  _c("w-spacer"),
                  _c("app-select-app", {
                    staticClass: "app-select mr",
                    attrs: { items: _vm.apps, value: _vm.app },
                    on: {
                      input: function ($event) {
                        return _vm.onAppInput($event)
                      },
                    },
                  }),
                  _c(
                    "w-button-bar",
                    { staticClass: "mr" },
                    [
                      _c(
                        "w-button",
                        { attrs: { to: "/roadmap/new" } },
                        [_c("w-fa", { attrs: { icon: "plus" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          attrs: {
                            disabled: _vm.editDisabled,
                            to: _vm.editLink,
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "pen" } })],
                        1
                      ),
                      _c(
                        "w-button",
                        {
                          attrs: { disabled: _vm.deleteDisabled },
                          on: {
                            click: function ($event) {
                              return _vm.deleteItems()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "trash" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-button-bar",
                    [
                      _c(
                        "w-button",
                        { attrs: { to: _vm.priorityEditLink } },
                        [
                          _c("w-fa", {
                            attrs: { icon: "sort-amount-down-alt" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { staticStyle: { "flex-grow": "1", "flex-shrink": "1" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-data-table", {
                staticStyle: { "flex-grow": "1" },
                attrs: {
                  items: _vm.items,
                  columns: _vm.columns,
                  "selected-items": _vm.selectedItems,
                },
                on: {
                  "item-clicked": function ($event) {
                    return _vm.edit($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }